/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeRef,
  UnifiedClassTypeRefOptional,
  UnifiedClassTypeRefMetaI,
  UnifiedClassTypeRefTrackedI,
} from "./unified-class-type-ref";
import {
  UnifiedClassTypeRefTracked,
  UnifiedClassTypeRefMeta,
} from "./unified-class-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithTypeName,
  WithTypeNameOptional,
  WithTypeNameMetaI,
  WithTypeNameTrackedI,
} from "./with-type-name";
import { WithTypeNameTracked, WithTypeNameMeta } from "./with-type-name";

/**
 *
 * @export
 * @interface ClassTypeRefWithName
 */
export interface ClassTypeRefWithNameOptional extends UnifiedClassTypeRefOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeRefWithName
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeRefWithName
   */
  typeName?: string;
}

export interface ClassTypeRefWithName
  extends ClassTypeRefWithNameOptional, UnifiedClassTypeRef, WithTypeName {
  /**
   *
   * @type {number}
   * @memberof ClassTypeRefWithName
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeRefWithName
   */
  typeName?: string;
}

export interface ClassTypeRefWithNameTrackedI extends UnifiedClassTypeRefOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeRefWithName
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeRefWithName
   */
  typeName?: string;
  typeNameIsSet: boolean;
}

transformDatesMap.set(
  "ClassTypeRefWithName",
  function (model: ClassTypeRefWithName) {},
);

export type ClassTypeRefWithNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassTypeRefWithNameMeta: ClassTypeRefWithNameMetaI =
  {} as ClassTypeRefWithNameMetaI;
ClassTypeRefWithNameMeta = typeMeta("ClassTypeRefWithName", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
});

const metaI = ClassTypeRefWithNameMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassTypeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([WithTypeNameMeta]);
  metaI.typeName.inheritedFrom = WithTypeNameMeta.typeName;
});

export class ClassTypeRefWithNameTracked
  extends UnifiedClassTypeRefTracked
  implements ClassTypeRefWithNameTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  constructor(config?: ClassTypeRefWithNameOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ClassTypeRefWithNameOptional,
    options?: AssignOptions,
  ): ClassTypeRefWithNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassTypeRefWithNameTrackedI {
    const cloned = {} as ClassTypeRefWithNameTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassTypeRefWithNameTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeRefWithNameMeta.assignId,
      ClassTypeRefWithNameMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeRefWithNameMeta.typeName,
      ClassTypeRefWithNameMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
